
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1315Dialog extends Serenity.EntityDialog<Report_1315Row, any> {
        protected getFormKey() { return Report_1315Form.formKey; }
        protected getIdProperty() { return Report_1315Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1315Row.localTextPrefix; }
        protected getNameProperty() { return Report_1315Row.nameProperty; }
        protected getService() { return Report_1315Service.baseUrl; }
        protected getDeletePermission() { return Report_1315Row.deletePermission; }
        protected getInsertPermission() { return Report_1315Row.insertPermission; }
        protected getUpdatePermission() { return Report_1315Row.updatePermission; }

        protected form = new Report_1315Form(this.idPrefix);

    }
}